import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  tabsWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    justifyContent: 'center',
    position: 'sticky',
    top: '-20px',
    zIndex: theme.zIndex.tabsWrapper,
    '& > div': {
      width: '100%',
      backgroundColor: theme.colors.white,
    },
  },
}));

export default useStyles;